<template>
  <div class="container-fluid password-container" :class="{ hide_banner: !isTokenValid }">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <div class="login-whitebox" v-if="isTokenValid">
          <div class="col-sm-12 pass-info">
            <p class="pass-desc">Provide Password Details:</p>
            <el-popover
              popper-append-to-body="false"
              placement="bottom-end"
              class="info-icon-class"
              trigger="click"
              popper-class="popup-background tootip-custom-small-width-class"
              @show="passwordInfoActive = true"
              @hide="passwordInfoActive = false"
            >
              <div class="content">
                <ul class="word-break">
                  <li>
                    Your password must be at least 10 characters and meet any 3 of these 4 criteria:
                    1 capital letter (A-Z), 1 lowercase letter ( a-z), 1 number (1-9), and one
                    special character (!@#$.,+=( )_%^&*)
                  </li>
                </ul>
              </div>
              <img
                class="info-img"
                src="/static/images/icons/info_icon.svg"
                v-if="!passwordInfoActive"
                alt="info-icon"
                slot="reference"
              />
              <img
                class="info-img"
                src="/static/images/icons/info_icon_active.svg"
                v-if="passwordInfoActive"
                alt="infoactive-icon"
                slot="reference"
              />
            </el-popover>
          </div>
          <div class="login-container">
            <form @submit.prevent="resetPassword">
              <div class="col-sm-12 login-input form-group">
                <label for="email">New Password</label>
                <span class="required_astric">*</span>
                <div class="password-flex">
                  <input
                    ref="inputNewTag"
                    class="login-input-box landing-input-field"
                    v-model.trim="$v.data.password.$model"
                    type="password"
                    name="password"
                    placeholder="New password"
                    :class="{ field_error: $v.data.password.$error }"
                  />
                  <img
                    v-if="showNewPassword"
                    src="/static/images/icons/eye.svg"
                    class="eye-icon"
                    @click="toggleNewPassword"
                    alt="eye-icon"
                  />
                  <img
                    v-if="!showNewPassword"
                    src="/static/images/icons/eye_slash.svg"
                    class="eye-slash-icon"
                    @click="toggleNewPassword"
                    alt="eye-icon"
                  />
                </div>
                <div class="error_text" v-if="$v.data.password.$error">
                  <div v-if="!$v.data.password.required">Password is required.</div>
                  <div v-if="$v.data.password.required && !$v.data.password.passwordValidation">
                    Your password must be at least 10 characters and meet any 3 of these 4 criteria:
                    1 capital letter (A-Z), 1 lowercase letter ( a-z), 1 number (1-9), and one
                    special character (!@#$.,+=( )_%^&*)
                  </div>
                </div>
              </div>
              <div class="col-sm-12 login-input form-group mb-32">
                <label for="email">Confirm Password</label>
                <span class="required_astric">*</span>
                <div class="password-flex">
                  <input
                    ref="inputConfirmTag"
                    class="login-input-box landing-input-field"
                    v-model.trim="$v.data.confirm_password.$model"
                    type="password"
                    name="confirm_password"
                    placeholder="Confirm Password"
                    :class="{ field_error: $v.data.confirm_password.$error }"
                  />
                  <img
                    v-if="showConfirmPassword"
                    src="/static/images/icons/eye.svg"
                    class="eye-icon"
                    @click="toggleConfirmPassword"
                    alt="eye-icon"
                  />
                  <img
                    v-if="!showConfirmPassword"
                    src="/static/images/icons/eye_slash.svg"
                    class="eye-slash-icon"
                    @click="toggleConfirmPassword"
                    alt="eye-icon"
                  />
                </div>
                <div class="error_text" v-if="$v.data.confirm_password.$error">
                  <div v-if="!$v.data.confirm_password.required">Please confirm your password</div>
                  <div
                    v-if="
                      $v.data.confirm_password.required && !$v.data.confirm_password.sameAsPassword
                    "
                  >
                    The password doesn't match the password above
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="d-flex terms-block">
                  <span class="checkbox mr-12">
                    <label>
                      <input
                        type="checkbox"
                        value="true"
                        v-model.trim="$v.data.terms_conditions.$model"
                      />
                      <span class="cr">
                      </span>
                    </label>
                  </span>
                  <span class="terms-conditions">
                    I acknowledge that I have read and agreed to the
                    <a href="/terms-of-service" target="_blank"
                      >RAMS Software-as-a-Service Agreement</a
                    >
                  </span>
                </div>
                <div class="error_text pl-40" v-if="$v.data.terms_conditions.$error">
                  <div v-if="!$v.data.terms_conditions.checked">
                    You must accept the RAMS SaaS Agreement to proceed
                  </div>
                </div>
              </div>
              <div class="col-sm-12 emergo-button">
                <button class="btn emergo-green-button" type="submit" :disabled="disableButton">
                  {{ ButtonText }}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div v-if="linkExpired">
          <invalid-token-message :page="'resetpassword'"></invalid-token-message>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Popover } from 'element-ui';
import { required, sameAs, helpers } from 'vuelidate/lib/validators';
import { resetPassword, validateResetToken } from '../../apis/passwords';
import { PasswordValidation } from '../../utils/common';
import InvalidTokenMessage from '../UIComponents/InvalidTokenMessage.vue';

const passwordValidation = helpers.regex('passwordValidation', PasswordValidation);

export default {
  data() {
    return {
      showNewPassword: true,
      showConfirmPassword: true,
      passwordInfoActive: false,
      data: { password: '', confirm_password: '', terms_conditions: false },
      isTokenValid: false,
      linkExpired: false,
      disableButton: false,
      ButtonText: 'Change Password'
    };
  },
  components: {
    InvalidTokenMessage,
    'el-popover': Popover
  },
  validations: {
    data: {
      password: {
        required,
        passwordValidation
      },
      confirm_password: {
        required,
        // eslint-disable-next-line func-names
        sameAsPassword: sameAs(function () {
          return this.data.password;
        })
      },
      terms_conditions: {
        checked(value) {
          return value;
        }
      }
    }
  },
  async created() {
    await this.validateToken();
  },
  methods: {
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
      if (!this.showConfirmPassword) {
        this.$refs.inputConfirmTag.type = 'text';
      } else {
        this.$refs.inputConfirmTag.type = 'password';
      }
    },
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
      if (!this.showNewPassword) {
        this.$refs.inputNewTag.type = 'text';
      } else {
        this.$refs.inputNewTag.type = 'password';
      }
    },
    async resetPassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.disableButton = true;
        this.ButtonText = 'Submitting...';
        const result = await resetPassword(this.data, this.$route.params.token);
        this.disableButton = false;
        this.ButtonText = 'Change Password';
        if (result.status) {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'success',
            title: 'Success',
            text: result.message,
            group: 'custom-notification'
          });
          this.$router.push({ name: 'login' });
        } else if (!result.status && result.message === 'invalid') {
          this.isTokenValid = false;
          this.linkExpired = true;
        } else if (!result.status) {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: result.message,
            group: 'custom-notification'
          });
        }
      }
    },
    async validateToken() {
      const result = await validateResetToken(this.$route.params.token);
      if (result.token !== 'valid') {
        this.isTokenValid = false;
        this.linkExpired = true;
      } else {
        this.isTokenValid = true;
        this.linkExpired = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin emergoGreenBtnProps {
  background: $light-green !important;
  border-color: $light-green !important;
  color: $deep-white !important;
  outline: none;
}
.btn {
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 30px;
}
.password-container {
  color: $deep-black;
  background-image: url(/static/images/logos/World_Map_Login.svg);
  background-repeat: no-repeat;
  background-size: 100%;
}
.pass-desc {
  font-style: normal;
  @include fontItems($font-18, 21px, $font-weight-400);
  color: $dark-black-alpha;
  margin: 40px 32px 32px 15px;
  text-align: left;
}
.login-whitebox {
  background: $deep-white;
  border: 0.8px solid $gray74;
  border-radius: $radius10;
  padding: 0px;
  display: inline-block;
  margin-top: 60px;
  margin-bottom: 25px;
  .info-icon-class {
    margin-top: 40px;
  }
  .info-img {
    position: absolute;
    right: 35px;
  }
}
.pass-info {
  display: flex;
}
.login-container {
  margin-bottom: 40px;
}
.login-input {
  &.form-group {
    font-style: normal;
    @include fontItems($font-14, 16px, $font-weight-400);
    color: $dark-black-alpha;
    text-align: left;
    padding: 0px 32px;
    &:first-of-type {
      margin-bottom: 40px;
    }
    &.mb-32 {
      margin-bottom: 32px;
    }
  }
}
.form-group {
  label {
    padding-right: 5px;
  }
}
.required_astric {
  color: $deep-thick-danger;
}
.login-input-box {
  font-style: normal;
  @include fontItems($font-16, 19px, $font-weight-400);
  color: $dark-black-alpha;
  background: $deep-white;
  border: 0.5px solid $black;
  border-radius: 3px;
  display: block;
  width: 100%;
  height: 34px;
  margin-top: 5px;
  padding: 6px 12px;
}
.terms-conditions {
  font-weight: $font-weight-400;
  font-size: $font-16;
  text-align: left;
  a {
    font-weight: 700;
    color: $messenger-blue;
  }
}
.emergo-button {
  padding: 0px 32px 40px 32px;
}
.emergo-green-button {
  padding: 7px 30px;
  width: 100%;
  color: $deep-white;
  margin-top: 40px;
}
.field_error {
  border-color: $deep-thick-danger;
}
.error_text {
  font-style: normal;
  font-weight: $font-weight-400;
  font-size: $font-12;
  line-height: 14px;
  color: $deep-thick-danger;
  text-align: left;
  margin: 0px;
  background-color: transparent;
  padding-top: 10px;
  padding-left: 0px;
  &.pl-40 {
    padding-left: 40px;
  }
}
.emergo-green-button {
  &:hover {
    &:not(:disabled) {
      @include emergoGreenBtnProps();
    }
  }
  &:active,
  &.active {
    &:hover {
      &:not(:disabled) {
        @include emergoGreenBtnProps();
      }
    }
  }
}
.terms-block{
  padding-left: 17px;
  padding-right: 17px;
}
.password-flex {
  display: flex;
  input {
    padding: 6px 43px 6px 12px;
  }
}
.eye-icon,
.eye-slash-icon {
  margin-left: -35px;
  width: 18px;
  height: 18px;
  margin-top: 13px;
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .login-whitebox {
    min-width: 85vw !important;
  }
}
@media (min-width: 768px) and (max-width: 912px) {
  .password-container {
    min-height: 70vh;
  }
  .login-whitebox {
    margin-top: 100px;
  }
}
@media only screen and (max-width: 991px) {
  .password-container {
    background-size: unset;
  }
}
</style>
